import { fetchData } from "lib/helpers/fetchData";
import { getApiUrl } from "lib/helpers/getApiUrl";

export const generateRequestTypeMappings = async (customerId, projectId, instanceId) => {
  if (projectId?.length) {
    const instanceIdParam = instanceId ? `&instanceId=${instanceId}` : "";

    try {
      await fetchData(`${getApiUrl("INTEGRATIONS_API")}/generate-request-type-mappings/${customerId}?projectId=${projectId}${instanceIdParam}`, null, "POST");
    } catch (error) {
      return { success: false, errorMessage: "An error occurred whilst attempting to populate Jira request types for the customer and no settings were changed. Please try again or contact the development team." };
    }
  }

  return { success: true };
};